import React, { useEffect, useState } from "react";
import "./ScrollToTopButton.css";

const ScrollToTopButton = () => {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isOverFooter, setIsOverFooter] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const scrollPercent = (scrollTop / docHeight) * 100;
      setProgress(scrollPercent);
      setShow(scrollTop > window.innerHeight * 0.1);

      // Check if we're in footer section
      const footer = document.querySelector('footer');
      if (footer) {
        const footerTop = footer.offsetTop;
        const footerHeight = footer.offsetHeight;
        const viewportHeight = window.innerHeight;
        const currentPos = scrollTop + viewportHeight * 0.5; // Button's center position
        
        setIsOverFooter(currentPos > footerTop);
      } else {
        setIsOverFooter(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    // Initial check
    handleScroll();
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className={`scroll-strip ${show ? "show" : ""} ${isOverFooter ? "in-footer" : ""}`}>
      <div className="scroll-inner" onClick={scrollToTop}>
        <span className="scroll-text">Scroll to top</span>
        <div className="scroll-line-wrapper">
          <span
            className="scroll-line-progress"
            style={{ height: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ScrollToTopButton;